import * as React from 'react';

import type { PageProps } from 'gatsby';
import type { HeadProps } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import lab from 'stile-shared/static/lab.svg';
import society from 'stile-shared/static/society.svg';
import arrowRight from 'stile-shared/static/subdirectory_arrow_right.svg';
import styled from 'styled-components';

import activeEarth from 'stile-shared/assets/images/curriculum/active_earth.jpg';
import andy from 'stile-shared/assets/images/curriculum/andy.jpg';
import bodySystems from 'stile-shared/assets/images/curriculum/body_systems.jpg';
import filming from 'stile-shared/assets/images/curriculum/byron_filming.jpg';
import cells from 'stile-shared/assets/images/curriculum/cells.jpg';
import climateChange from 'stile-shared/assets/images/curriculum/climate_change.jpg';
import earthSystems from 'stile-shared/assets/images/curriculum/earth_systems.jpg';
import ecosystems from 'stile-shared/assets/images/curriculum/ecosystems.jpg';
import elementsAndCompounds from 'stile-shared/assets/images/curriculum/elements_and_compounds.jpg';
import energy from 'stile-shared/assets/images/curriculum/energy.jpg';
import energyConservation from 'stile-shared/assets/images/curriculum/energy_conservation.jpg';
import evolution from 'stile-shared/assets/images/curriculum/evolution.jpg';
import foodChainsAndFoodWebs from 'stile-shared/assets/images/curriculum/food_chains.jpg';
import genetics from 'stile-shared/assets/images/curriculum/genetics.jpg';
import heat from 'stile-shared/assets/images/curriculum/heat.jpg';
import humanImpact from 'stile-shared/assets/images/curriculum/human_impact.jpg';
import importanceofBio from 'stile-shared/assets/images/curriculum/importance_of_bio.jpg';
import kat from 'stile-shared/assets/images/curriculum/kat.jpg';
import mark from 'stile-shared/assets/images/curriculum/mark.jpg';
import nervousSystem from 'stile-shared/assets/images/curriculum/nervous_system.jpg';
import newton from 'stile-shared/assets/images/curriculum/newton.jpg';
import nonContactForces from 'stile-shared/assets/images/curriculum/non-contact.jpg';
import OrangeArrow from 'stile-shared/assets/images/curriculum/orange_arrow.svg';
import OrangeArrowMobile from 'stile-shared/assets/images/curriculum/orange_arrow_mobile.svg';
import ourPlaceInSpace from 'stile-shared/assets/images/curriculum/our_place_in_space.jpg';
import physicalAndChemicalChange from 'stile-shared/assets/images/curriculum/physical_and_chemical.jpg';
import PinkArrow from 'stile-shared/assets/images/curriculum/pink_arrow.svg';
import PinkArrowMobile from 'stile-shared/assets/images/curriculum/pink_arrow_mobile.svg';
import plants from 'stile-shared/assets/images/curriculum/plants.jpg';
import school from 'stile-shared/assets/images/curriculum/school_filming.jpg';
import statesOfMatter from 'stile-shared/assets/images/curriculum/states_of_matter.jpg';
import stickyNotes from 'stile-shared/assets/images/curriculum/sticky_notes.jpg';
import survivalOfSpecies from 'stile-shared/assets/images/curriculum/survival_of_species.jpg';
import tShirt from 'stile-shared/assets/images/curriculum/t-shirt.jpg';
import waves from 'stile-shared/assets/images/curriculum/waves.jpg';

import { Button } from 'stile-shared/src/components/2024/common/Button';
import { ExploreCurriculum } from 'stile-shared/src/components/2024/common/ExploreCurriculum';
import { Icon } from 'stile-shared/src/components/2024/common/Icon';
import WITBStatsSection from 'stile-shared/src/components/2024/common/Included/WITBStatsSection/WITBStatsSection';
import LessonSwiperComponent, {
  LessonTile,
} from 'stile-shared/src/components/2024/common/LessonSwiper';
import ThreeCardComponent from 'stile-shared/src/components/2024/common/ThreeCardComponent';
import { Section } from 'stile-shared/src/components/2024/layout/Section';
import VideoGallery from 'stile-shared/src/components/2024/layout/VideoGallery';

import { PageLayout } from 'templates/2024/PageLayout';
import { SEO } from 'templates/2024/SEO';

export function Head(props: HeadProps) {
  return (
    <>
      <SEO slug={props.location.pathname} />
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link
        href="https://fonts.googleapis.com/css2?family=Shantell+Sans:wght@400;500;600;700&display=swap"
        rel="stylesheet"
      />
    </>
  );
}

const MiddleSchoolCurriculumLayout = styled<typeof PageLayout>(PageLayout)`
  @media (max-width: 768px) {
    .header-wrapper {
      background-color: var(--stile-green-2);
    }
  }

  .textBlock {
    padding: 0 0 108px 0;
  }
  @media (max-width: 768px) {
    .underline-20:after {
      width: 60.128px;
      height: 14.26px;
      right: 0px;
    }
    .textBlock {
      padding: 0 0 28px 0;

      .grid-layout {
        margin-top: 0 !important;
      }
    }
  }
  .hearts {
    display: inline-block;
    left: 40px;
    @media (max-width: 768px) {
      display: flex;
      justify-content: end;
      top: 30px;
      left: 0px;
    }
  }
`;

const Banner = styled<typeof Section>(Section)`
  h4 {
    color: white;
    margin: 0 0 32px;
  }
  h1 {
    margin: 0;
  }
  @media (max-width: 768px) {
    &:first-child {
      .content {
        padding-top: 17px !important;
      }
    }
    .content {
      padding-top: 60px !important;
    }
  }
`;
const StickyNote = styled.div`
  background: #d0eedc;
  box-shadow: 0px 19px 19px 0px rgba(0, 0, 0, 0.06), 0px 5px 11px 0px rgba(0, 0, 0, 0.07);
  width: 100%;
  padding: 30px 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 40px;
  height: 100%;
  min-height: 368px;
  h5 {
    font-family: Boing;
    font-size: 32px;
    font-weight: 500;
    line-height: 125%;
    letter-spacing: -0.352px;
    flex: 1;
  }
  .h7 {
    min-height: 96px;
    flex-shrink: 0;
    max-width: 272px;
  }
  mark {
    background: rgba(0, 165, 65, 0.2);
    padding: 0 2px;
  }
  @media (max-width: 768px) {
    height: 100%;
    gap: 20px;
    min-height: 320px;
    h5 {
      font-size: 26px;
      line-height: 28px;
      flex: 1;
    }
    .h7 {
      min-height: 60px;
      flex-shrink: 0;
      font-size: 14px;
      line-height: 20px;
    }
  }
`;
const PTAWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 150px;
  padding-top: 50px;
  overflow: hidden;
  .content {
    .grid-layout {
      margin-top: 25px !important;
    }
  }
  @media (max-width: 768px) {
    padding-bottom: 60px;
    padding-top: 40px;
    .content {
      padding-top: 20px !important;

      .grid-layout {
        margin-top: 20px !important;
      }
    }
  }
`;
const MobileOverflowComponent = styled.div`
  max-width: 1160px;
  justify-self: center;
  @media (max-width: 1220px) {
    padding: 0 60px;
  }
  @media (max-width: 768px) {
    padding: 0 25px;
  }
`;
const StickyNotesSection = styled(MobileOverflowComponent)`
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, auto);
  gap: 80px 28px;
  display: grid;
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 1fr);
  }
  @media (max-width: 768px) {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    gap: 12px;
    overflow-x: auto;
    overflow-y: hidden;
    width: 100%;
    position: relative;
    padding-bottom: 50px;

    & > div {
      flex: 0 0 300px;
      min-width: 300px;
      scroll-snap-align: start;
    }
    &::-webkit-scrollbar {
      display: none;
    }
    scrollbar-width: none;
  }
`;
const SideBySide = styled(MobileOverflowComponent)`
  margin: 110px 0 150px;
  @media (max-width: 768px) {
    margin: 20px 0 60px;
  }
`;

const PTAAcademySection = styled<typeof Section>(Section)`
  margin: 0;
  padding: 0 0 0 0;
  grid-column: span 12;
  position: relative;
  &:last-child {
    padding-bottom: 150px;
    @media (max-width: 768px) {
      padding-bottom: 30px;
    }
  }
  p {
    grid-column: 4 / span 6;
    text-align: center;
  }
  .diagram {
    grid-column: 1 / span 12;
    margin-top: 80px;
  }
  .red {
    color: #ef4e4a;
  }
  .green {
    color: var(--stile-green-3);
  }
  .red,
  .green,
  .bold {
    font-weight: 600;
  }
  @media (max-width: 768px) {
    h2 {
      margin-bottom: 24px !important;
    }
    padding: 0;
    .content {
      padding: 0;
    }
    p {
      grid-column: 1 / span 12;
    }
  }
  .subheading {
    align-self: center;
  }
  .subheader {
    grid-column: 3 / span 8;
    text-align: center;
    margin: 0;

    h4 {
      margin-bottom: 32px;
      @media (max-width: 768px) {
        marign-bottom: 20px;
      }
    }

    p {
      margin: 0;
    }
    @media (max-width: 768px) {
      grid-column: 1 / span 12;

      p {
        &:first-child {
          margin-top: 0;
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  .content {
    .grid-layout {
      grid-column: span 12;
      align-items: center;
    }

    @media (max-width: 768px) {
      padding-top: 20px !important;
      .grid-layout {
        margin-bottom: 16px !important;
      }
    }
  }
`;

const ScopeAndSequence = styled(PTAAcademySection)`
  padding-bottom: 80px;
  @media (max-width: 768px) {
    padding: 0;
  }
`;

const UnitTypesTable = styled.table`
  grid-column: 1 / span 12;
  width: 100%;
  border-collapse: collapse;
  margin: 40px 0;
  p {
    text-align: left;
  }

  th {
    text-align: left;
    padding: 24px;
    vertical-align: middle;
    border: 1px solid #e5e5e5;
    background-color: #f8f8f8;
    color: var(--stile-grey-6);
    width: 33.33%;
    .dark {
      color: var(--stile-grey-8);
    }
    .model-icon,
    .anchoring-icon {
      display: inline-flex;
      align-items: center;
      gap: 8px;
    }
  }

  td {
    padding: 22px 24px;
    vertical-align: top;
    border: 1px solid #e5e5e5;
    h6 {
      color: var(--stile-green-3);
      padding-bottom: 15px;
    }
    .--small {
      padding-bottom: 10px;
    }

    .unit-example {
      h6 {
        color: var(--stile-grey-8);
      }
      .h8,
      .--small {
        padding: 0;
      }
      .--small {
        color: var(--stile-grey-6);
      }
      .gatsby-image-wrapper {
        margin: 14px 0 20px;
        max-width: 130px;
        border-radius: 5.799px;
        box-shadow: 0px 19px 19px 0px rgba(0, 0, 0, 0.06), 0px 5px 11px 0px rgba(0, 0, 0, 0.07);
      }

      .phenomenon,
      .activity {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        margin-bottom: 12px;
      }
    }
  }

  @media (max-width: 1024px) {
    th {
      h6 {
        font-size: 19px;
        line-height: 24px;
      }
    }
  }
`;

const DevelopmentalProgression = styled.div`
  width: 100%;
  display: flex;
  background-color: var(--stile-grey-1);
  justify-content: center;
`;
const Progress = styled(MobileOverflowComponent)`
  margin: 90px 0;
  display: grid;
  grid-template-columns: 1fr auto 1fr auto 1fr;
  min-height: 626px;
  @media (max-width: 768px) {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    gap: 12px;
    overflow-x: auto;
    overflow-y: hidden;
    width: 100%;
    position: relative;
    min-height: auto;
    margin: 24px 0 40px;

    &::-webkit-scrollbar {
      display: none;
    }
    scrollbar-width: none;
  }
  .lesson-tile-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    & > .lesson-tile-inner {
      transform: scale(0.75);
      transform-origin: top left;
      .lesson-tile {
        margin-bottom: 20px !important;
      }
    }
    @media (max-width: 768px) {
      width: calc(100%);
      flex: 0 0 auto;
      margin-bottom: 16px;
      .lesson-tile-inner {
        transform: scale(1);
      }
    }
  }
  .pink-arrow,
  .orange-arrow {
    grid-column: span 1;
    margin-right: 30px;
    align-self: start;
    background-repeat: no-repeat;
    background-position: center bottom;
    background-size: contain;
    width: 80px;
    height: 200px;
    @media (max-width: 768px) {
      flex: 0 0 40px;
      min-width: 40px;
      margin-right: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background-position: center;
    }
  }
  .pink-arrow {
    background-image: url('${PinkArrow}');
    padding-top: 300px;
    @media (max-width: 768px) {
      background-image: url('${PinkArrowMobile}');
      padding-top: 0;
    }
  }
  .orange-arrow {
    background-image: url('${OrangeArrow}');
    padding-top: 430px;
    @media (max-width: 768px) {
      background-image: url('${OrangeArrowMobile}');
      padding-top: 0;
    }
  }
  .unit2,
  .unit4,
  .unit5 {
    .--feature_heading {
      margin-top: calc(-25%);
      @media (max-width: 768px) {
        margin-top: 0;
      }
    }
    max-width: 259px;
    h3 {
      color: var(--white);
      text-align: center;
      font-family: 'Shantell Sans';
      font-size: 16px;
      font-weight: 700;
      line-height: 26px;
      border-radius: 25px;
      margin-bottom: 8px;
      width: 75%;
      @media (max-width: 768px) {
        width: 100%;
        font-size: 14px;
        line-height: 20px;
      }
    }
    @media (max-width: 768px) {
      flex: 0 0 60%;
      min-width: 60%;
      scroll-snap-align: start;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }
  }
  .unit2 {
    align-self: start;
    h3 {
      background: var(--Secondary-Teal, #20b7a7);
    }
    .highlight {
      color: var(--Secondary-Teal, #20b7a7);
    }
    @media (max-width: 768px) {
      align-self: stretch;
    }
  }
  .unit4 {
    align-self: center;
    h3 {
      background: var(--Secondary-Pink, #f06893);
    }
    .highlight {
      color: var(--Secondary-Pink, #f06893);
    }
    @media (max-width: 768px) {
      align-self: stretch;
    }
  }
  .unit5 {
    align-self: end;
    h3 {
      background: var(--Secondary-Orange, #f5871f);
    }
    .highlight {
      color: var(--Secondary-Orange, #f5871f);
    }
    @media (max-width: 768px) {
      align-self: stretch;
    }
  }
}
`;
const TeachingPlanSection = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  .reverse-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    max-width: 1200px;
    width: 100%;
    gap: 60px;
  }

  .right {
    flex: 1;
    max-width: 566px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
      border-radius: 32px;
    }
    border-radius: 32px;
    box-shadow: 0px 43px 26px 0px rgba(0, 0, 0, 0.04), 0px 19px 19px 0px rgba(0, 0, 0, 0.06),
      0px 5px 11px 0px rgba(0, 0, 0, 0.07);
  }

  .left-text {
    max-width: 498px;
    flex: 1;
  }
  a {
    margin-top: 32px;
  }
  h4 {
    margin-bottom: 32px;
    margin-top: 0;
  }
  @media (max-width: 768px) {
    .right {
      margin-top: 10px;
      border-radius: 20px;
      img {
        border-radius: 20px;
      }
    }
    .reverse-container {
      flex-direction: column;
      align-items: flex-start;
      gap: 20px;
    }
    .left-text {
      a {
        margin-top: 28px;
      }
    }
    h2 {
      margin-bottom: 20px;
    }
  }
`;
const StyledVideoGallery = styled(VideoGallery)`
  margin-top: 80px;
  @media (max-width: 768px) {
    padding: 0 !important;
    margin-top: 24px;
  }
`;
function MiddleSchoolCurriculumPage(props: PageProps) {
  const grade6Lessons = [
    {
      coverImage: cells,
      name: 'Cells',
      description: 'Would you donate a part of your body to save a life?',
    },
    {
      coverImage: bodySystems,
      name: 'Body Systems',
      description: 'What does it take to be a cold-blooded killer?',
    },
    {
      coverImage: nervousSystem,
      name: 'The Nervous System',
      description: 'How can your gut influence your mood?',
    },
    {
      coverImage: plants,
      name: 'Plants',
      description: 'How can we feed an off-world colony?',
    },
    {
      coverImage: earthSystems,
      name: 'Earth Systems',
      description: 'How does our planet recycle?',
    },
    {
      coverImage: survivalOfSpecies,
      name: 'The Survival of Species',
      description: 'How do reproductive strategies help a species survive?',
    },
    {
      coverImage: climateChange,
      name: 'Climate Change',
      description: 'Climate change – how should we respond?',
    },
    {
      coverImage: energy,
      name: 'Energy',
      description: 'How can we learn from nature to improve energy technology?',
    },
    {
      coverImage: heat,
      name: 'Heat',
      description: 'How do you make the best pizza?',
    },
  ];
  const grade7Lessons = [
    {
      coverImage: foodChainsAndFoodWebs,
      name: 'Food Chains and Food Webs',
      description: 'Why do cats have slit-shaped pupils?',
    },
    {
      coverImage: importanceofBio,
      name: 'The Importance of Biodiversity',
      description: 'Do we need to save the bees?',
    },
    {
      coverImage: activeEarth,
      name: 'Active Earth',
      description: 'How do we build future-ready cities?',
    },
    {
      coverImage: statesOfMatter,
      name: 'States of Matter',
      description: 'Why is liquid water so important for humans to live on Mars?',
    },
    {
      coverImage: physicalAndChemicalChange,
      name: 'Physical and Chemical Change',
      description: 'What does chemistry have to do with chocolate making?',
    },
    {
      coverImage: ecosystems,
      name: 'Ecosystems',
      description: 'How can we prevent plastic from harming marine life?',
    },
    {
      coverImage: elementsAndCompounds,
      name: 'Elements and Compounds',
      description: 'If we need to mine lithium, how do we minimize the impact?',
    },
  ];
  const grade8Lessons = [
    {
      coverImage: ourPlaceInSpace,
      name: 'Our Place in Space',
      description: 'Can we travel to the Sun?',
    },
    {
      coverImage: energyConservation,
      name: 'Energy Conservation',
      description: 'Should we rely on hydropower for our energy needs?',
    },
    {
      coverImage: nonContactForces,
      name: 'Non-contact Forces and Electricity',
      description: 'Are we on track for sustainable transport?',
    },
    {
      coverImage: waves,
      name: 'Waves',
      description: 'How does someone on the other side of the world hear you?',
    },
    {
      coverImage: newton,
      name: "Newton's Laws of Motion",
      description: "How can we use Newton's Laws in car crash investigations?",
    },
    {
      coverImage: humanImpact,
      name: 'Human Impacts on Ecosystems',
      description: 'Are corals going extinct...again?',
    },
    {
      coverImage: genetics,
      name: 'Genetics',
      description: 'Can genes increase the risk of cancer?',
    },
    {
      coverImage: evolution,
      name: 'Evolution',
      description: 'Are we responsible for the rise of superbugs?',
    },
  ];
  const exploreCards = [
    {
      title: 'Stile X Workbooks',
      description:
        'Designed for hands-on learning and perfectly matched to the digital curriculum.',
      url: '/what-is-stile/stile-x/',
    },
    {
      title: 'Lab Kits',
      description: 'Everything you need for vibrant hands-on classrooms.',
      url: '/what-is-stile/lab-kits/',
    },
    {
      title: 'Professional Learning',
      description:
        'Master Stile at your own pace with evidence-based pedagogies and personalised support.',
      url: '/what-is-stile/stile-pl/',
    },
  ];

  const statsData = [
    { value: '62', label: 'topics' },
    { value: '1,144', label: 'lessons' },
    { value: '73', label: 'labs' },
    { value: '215', label: 'assessments' },
    { value: '1,317', label: 'videos' },
    { value: '10,918', label: 'questions' },
    { value: '58', label: 'career profiles' },
    { value: '52', label: 'simulations' },
  ];
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  return (
    <MiddleSchoolCurriculumLayout {...props}>
      <Banner
        className="textBlock"
        backgroundColor="--stile-green-2"
        headingContent={
          <h1 className="--jumbo">
            <h4>Stile’s Middle School Curriculum</h4>
            We aspire to make the best science lessons in the known universe. <br />
            <br />
            Here’s how we do it.
          </h1>
        }
      ></Banner>
      <PTAWrapper>
        <PTAAcademySection
          backgroundColor="--white"
          headingColor="--stile-grey-8"
          headingContent="What do students need to know and be capable of doing?"
          subHeadingContent="THE FOUNDATION"
          subHeadingColor="--stile-green-3"
          textColor="--stile-grey-8"
        />
        <StickyNotesSection>
          <StickyNote>
            <h5>
              What do students need to know in order to be <mark>scientifically literate?</mark>
            </h5>
            <h6 className="h7">Eg. How does antibiotic resistance work and why is it an issue?</h6>
          </StickyNote>
          <StickyNote>
            <h5>
              How is science <mark>relevant to careers</mark> other than being a scientist?
            </h5>
            <h6 className="h7">
              E.g. Chocolatiers use chemistry to create new textures and flavors.
            </h6>
          </StickyNote>
          <StickyNote>
            <h5>
              How do we teach students the <mark>language</mark> of science?
            </h5>
            <h6 className="h7">
              E.g. Mathematical thinking: creating models, interpreting, analyzing and visualising
              data.
            </h6>
          </StickyNote>
          <StickyNote>
            <h5>
              How science intersects with <mark>society</mark>, and how it likely will{' '}
              <mark>tomorrow?</mark>
            </h5>
            <h6 className="h7">
              E.g. Understanding the economic, environmental and social factors slowing the
              deployment of more renewable energy.
            </h6>
          </StickyNote>
          <StickyNote>
            <h5>
              What <mark>skills</mark> and <mark>dispositions</mark> are needed to be critical
              thinkers?
            </h5>
            <h6 className="h7">
              E.g. Evaluating claims using evidence, understanding the statistical significance of
              that evidence.
            </h6>
          </StickyNote>
          <StickyNote>
            <h5>
              We then fill in the rest to ensure we <mark>completely cover</mark> the standards
            </h5>
            <h6 className="h7">E.g. The NGSS, as well as State-specific standards.</h6>
          </StickyNote>
        </StickyNotesSection>

        <PTAAcademySection
          backgroundColor="transparent"
          headingColor="--stile-grey-8"
          headingContent={
            <>
              Combine proven best-practices with what <em>actually</em> works in real classrooms
            </>
          }
          subHeadingContent="DEFINING OUR APPROACH"
          subHeadingColor="--stile-green-3"
          textColor="--stile-grey-8"
        ></PTAAcademySection>
        <ThreeCardComponent
          cards={[
            {
              heading: 'A Framework for K-12 Science Education',
              copy: 'We use the Framework for K-12 Science Education as the foundation of our curriculum.',
              image: (
                <StaticImage
                  src="../../../../stile-shared/assets/images/curriculum/k_12.png"
                  alt="K-12"
                  quality={100}
                />
              ),
            },
            {
              heading: 'Evidence-based pedagogies',
              copy: 'We then weave in evidence-based pedagogies, using the ones that best fit the context of the lesson and unit.',
              image: (
                <StaticImage
                  src="../../../../stile-shared/assets/images/curriculum/pedagogies.png"
                  alt="Pedagogies"
                  quality={100}
                />
              ),
            },
            {
              heading: 'High-impact teaching strategies',
              copy: 'Finally we make the use of high-impact teaching strategies the path of least resistance.',
              image: (
                <StaticImage
                  src="../../../../stile-shared/assets/images/curriculum/strategies.png"
                  alt="Strategies"
                  quality={100}
                />
              ),
            },
          ]}
        />

        {/* Analyse */}
        <PTAAcademySection
          backgroundColor="transparent"
          headingColor="--stile-grey-8"
          headingContent="Built by our in-house experts"
          subHeadingContent="BRINGING IT TOGETHER"
          subHeadingColor="--stile-green-3"
          textColor="--stile-grey-8"
        >
          <p>
            Our talented team of educators, scientists, artists and engineers create Stile’s
            curriculum in collaboration with an entourage of out-of-house practising teachers,
            pedagogy academics and subject-matter experts.
          </p>
        </PTAAcademySection>
        <StyledVideoGallery
          className="teachers"
          videoAspectRatio="1"
          items={[
            { type: 'img', url: kat },
            { type: 'img', url: stickyNotes },
            { type: 'img', url: tShirt },
            { type: 'img', url: mark },
            { type: 'img', url: filming },
            { type: 'img', url: andy },
            { type: 'img', url: school },
          ]}
        />
      </PTAWrapper>
      <Banner
        className="textBlock"
        backgroundColor="--stile-green-2"
        headingContent={
          <h1>
            <h4>The result?</h4>A complete science curriculum that teachers love to teach—and
            students love to learn.
          </h1>
        }
      ></Banner>
      <ScopeAndSequence
        backgroundColor="--stile-grey-1"
        headingContent="The middle school scope and sequence"
      >
        <p>
          A sequence of learning packed with phenomena that students actually want to discover for
          themselves.
        </p>
      </ScopeAndSequence>
      <LessonSwiperComponent heading="6th Grade" lessons={grade6Lessons} />
      <LessonSwiperComponent heading="7th Grade" lessons={grade7Lessons} />
      <LessonSwiperComponent heading="8th Grade" lessons={grade8Lessons} />
      <PTAAcademySection
        backgroundColor="--stile-grey-1"
        headingContent="Developmental progression"
      >
        <p>
          Under the hood you’ll find logical, scaffolded developmental progression through each
          grade.
          <br />
          <br />
          Of course, you can modify our scope to make it your own. Add units, move them around. With
          Stile, you’re in control.
          {/* <Button
          <br />
          <br />
            href="https://blog.stileeducation.com/the-science-of-stile-x-retrieval-practice/"
            newTab
            label="Learn more about customization"
            style="primary"
          /> */}
        </p>
      </PTAAcademySection>
      <DevelopmentalProgression>
        <Progress>
          <div className="unit2">
            <div className="lesson-tile-container">
              <h3>Unit 2 </h3>
              <div className="lesson-tile-inner">
                <LessonTile
                  lesson={{
                    coverImage: bodySystems,
                    name: 'Body Systems',
                    description: 'What does it take to be a cold-blooded killer?',
                  }}
                />
              </div>
              <span className="--feature_heading">
                Students build on their knowledge of{' '}
                <span className="highlight">cells, tissues, and organs</span> as they explore how
                they function within the <span className="highlight">body’s systems.</span>
              </span>
            </div>
          </div>

          <div className="pink-arrow" />
          <div className="unit4">
            <div className="lesson-tile-container">
              <h3>Unit 4 </h3>
              <div className="lesson-tile-inner">
                <LessonTile
                  lesson={{
                    coverImage: plants,
                    name: 'Plants',
                    description: 'How can we feed an off-world colony?',
                  }}
                />
              </div>
              <span className="--feature_heading">
                Students use their knowledge of cells and{' '}
                <span className="highlight">body systems</span> to consider the{' '}
                <span className="highlight">specialized cells </span>and structures that keep plants
                alive.
              </span>
            </div>
          </div>

          <div className="orange-arrow" />
          <div className="unit5">
            <div className="lesson-tile-container">
              <h3>Unit 5 </h3>
              <div className="lesson-tile-inner">
                <LessonTile
                  lesson={{
                    coverImage: earthSystems,
                    name: 'Earth Systems',
                    description: 'How does our planet recycle?',
                  }}
                />
              </div>
              <span className="--feature_heading">
                Students extend their understanding of{' '}
                <span className="highlight">systems in a new context</span> as they consider the
                movement of energy and matter between Earth’s systems.
              </span>
            </div>
          </div>
        </Progress>
      </DevelopmentalProgression>
      <PTAAcademySection headingContent="Units built on proven practices">
        <p>
          Stile’s middle school units are grounded in the{' '}
          <span className="green">5 E instructional model</span> and scaffold students to “extended
          abstract” thinking as defined in <span className="red">SOLO taxonomy</span>, where they
          can generalize their understanding and apply it in a new domain.
        </p>
        <p>
          Stile’s instructional framework was reviewed by Alan J. Reid (PhD) and Steve Ross (PhD)
          from{' '}
          <span className="bold">
            {' '}
            Johns Hopkins University’s Centre for Research and Reform in Education
          </span>
          . They determined that Stile’s curriculum is grounded in rigorous research and had a
          meticulously designed logic model.
          <br />
          <br />
          <Button
            href="/resources/johns-hopkins-report/"
            newTab={true}
            label={
              <div>
                <Icon iconId="document" iconSize="fontSize" style={{ marginRight: 10 }} />
                Download the full Johns Hopkins report
              </div>
            }
          />
        </p>
      </PTAAcademySection>
      {!isMobile && (
        <MobileOverflowComponent>
          <StaticImage
            src="../../../../stile-shared/assets/images/curriculum/5e_solo.png"
            alt="5E model and SOLO taxonomy"
            className="diagram"
            style={{ marginTop: '80px' }}
          />
        </MobileOverflowComponent>
      )}
      {!isMobile && (
        <PTAAcademySection headingContent="Varied units keep teaching and learning fresh">
          <p>
            Our units fall into one of the six following categories, each describing what drives
            student learning throughout the unit.
          </p>
          <UnitTypesTable>
            <thead>
              <tr>
                <th>
                  <h6>Model</h6>
                </th>
                <th>
                  <div className="model-icon">
                    <Icon src={society} iconSize="38px" />
                    <span>
                      <h6 className="dark">Science in society</h6>
                      <h6>anchoring phenomenon</h6>
                    </span>
                  </div>
                </th>
                <th>
                  <div className="anchoring-icon">
                    <Icon src={lab} iconSize="38px" />
                    <span>
                      <h6 className="dark">Scientific</h6>
                      <h6>anchoring phenomenon</h6>
                    </span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <h6>Project-driven learning</h6>
                  <div className="--small">
                    Students are exposed to the{' '}
                    <strong>culminating activity at the start of the unit.</strong>
                  </div>
                  <div className="--small">
                    <strong>The activity drives learning</strong> throughout the unit.
                  </div>
                </td>
                <td>
                  <div className="unit-example">
                    <h6 className="h8">Classification and Biodiversity</h6>
                    <StaticImage
                      src="../../../../stile-shared/assets/images/curriculum/importance_of_bio.jpg"
                      alt="Classification and Biodiversity"
                    />
                    <div className="phenomenon">
                      <Icon src={arrowRight} iconSize="24px" />
                      <div>
                        <div className="--small">Phenomenon</div>
                        <p>Do we need to save the bees?</p>
                      </div>
                    </div>
                    <div className="activity">
                      <Icon src={arrowRight} iconSize="24px" />
                      <div>
                        <div className="--small">Activity</div>
                        <p>Engineering challenge to solve declining bee population.</p>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div className="unit-example">
                    <h6 className="h8">Waves</h6>
                    <StaticImage
                      src="../../../../stile-shared/assets/images/curriculum/waves.jpg"
                      alt="Classification and Biodiversity"
                    />
                    <div className="phenomenon">
                      <Icon src={arrowRight} iconSize="24px" />
                      <div>
                        <div className="--small">Phenomenon</div>
                        <p>How do video calls work?</p>
                      </div>
                    </div>
                    <div className="activity">
                      <Icon src={arrowRight} iconSize="24px" />
                      <div>
                        <div className="--small">Activity</div>
                        <p>Create a model for global communication.</p>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <h6>Wonder to workshop</h6>
                  <div className="--small">
                    Students learn in the context of <strong>investigative phenomena.</strong>
                  </div>
                  <div className="--small">
                    There's a <strong>culminating activity at the end</strong> of the unit whereby
                    students apply their skills and knowledge in an "extended abstract" transfer
                    task.
                  </div>
                </td>
                <td>
                  <div className="unit-example">
                    <h6 className="h8">Energy Conservation</h6>
                    <StaticImage
                      src="../../../../stile-shared/assets/images/curriculum/energy_conservation.jpg"
                      alt="Classification and Biodiversity"
                    />
                    <div className="phenomenon">
                      <Icon src={arrowRight} iconSize="24px" />
                      <div>
                        <div className="--small">Phenomenon</div>
                        <p>Should we rely on hydropower for our energy needs?</p>
                      </div>
                    </div>
                    <div className="activity">
                      <Icon src={arrowRight} iconSize="24px" />
                      <div>
                        <div className="--small">Activity</div>
                        <p>Socratic seminar on the proposed Congo Dam.</p>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div className="unit-example">
                    <h6 className="h8">Human Impacts on Ecosystems</h6>
                    <StaticImage
                      src="../../../../stile-shared/assets/images/curriculum/human_impact.jpg"
                      alt="Classification and Biodiversity"
                    />
                    <div className="phenomenon">
                      <Icon src={arrowRight} iconSize="24px" />
                      <div>
                        <div className="--small">Phenomenon</div>
                        <p>Are corals going extinct again?</p>
                      </div>
                    </div>
                    <div className="activity">
                      <Icon src={arrowRight} iconSize="24px" />
                      <div>
                        <div className="--small">Activity</div>
                        <p>Awareness campaign about coral extinction.</p>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <h6>Phenomini</h6>
                  <div className="--small">
                    Students learn in the context of <strong>investigative phenomena.</strong>
                  </div>
                  <div className="--small">
                    There's <strong>no significant culminating activity.</strong>
                  </div>
                  <div className="--small">
                    These units are typically shorter than the other categories and provide a
                    lighter teaching and learning experience between heavier and lengthier units.
                  </div>
                </td>
                <td>
                  <div className="unit-example">
                    <h6 className="h8">Genetics</h6>
                    <StaticImage
                      src="../../../../stile-shared/assets/images/curriculum/genetics.jpg"
                      alt="Classification and Biodiversity"
                    />
                    <div className="phenomenon">
                      <Icon src={arrowRight} iconSize="24px" />
                      <div>
                        <div className="--small">Phenomenon</div>
                        <p>How can genes increase the risk of cancer?</p>
                      </div>
                    </div>
                    <div className="activity">
                      <Icon src={arrowRight} iconSize="24px" />
                      <div>
                        <div className="--small">Activity</div>
                        <p>No culminating activity.</p>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div className="unit-example">
                    <h6 className="h8">Food Chains and Food Webs</h6>
                    <StaticImage
                      src="../../../../stile-shared/assets/images/curriculum/food_chains.jpg"
                      alt="Classification and Biodiversity"
                    />
                    <div className="phenomenon">
                      <Icon src={arrowRight} iconSize="24px" />
                      <div>
                        <div className="--small">Phenomenon</div>
                        <p>Why do cats have slit-shaped pupils?</p>
                      </div>
                    </div>
                    <div className="activity">
                      <Icon src={arrowRight} iconSize="24px" />
                      <div>
                        <div className="--small">Activity</div>
                        <p>No culminating activity.</p>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </UnitTypesTable>
        </PTAAcademySection>
      )}
      <SideBySide>
        <TeachingPlanSection>
          <div className="reverse-container">
            <div className="left-text">
              <h4>See Stile’s pedagogical model in situ</h4>
              <p>
                Download the Teaching Plan for Stile’s Waves unit to see what our unit structure
                looks like in practice. The Teaching Plan outlines the phenomena, storyline and
                career profile, as well as the list of lessons, labs and assessments.
              </p>
              <Button
                href="/resources/teaching-guide/"
                newTab={true}
                label={
                  <div>
                    <Icon iconId="document" iconSize="fontSize" style={{ marginRight: 10 }} />
                    Download the Waves unit Teaching Plan
                  </div>
                }
              />
            </div>
            <div className="right">
              <StaticImage
                className="greyBorder"
                key={0}
                src="../../../../stile-shared/assets/images/curriculum/waves_unit.jpg"
                alt="Make Stile your own"
              />
            </div>
          </div>
        </TeachingPlanSection>
      </SideBySide>
      <WITBStatsSection title="Your core curriculum, ready to go" stats={statsData} />
      <ExploreCurriculum
        title="Explore our core science curriculum"
        exploreCardsData={exploreCards}
        image={
          <StaticImage
            src="../../../../stile-shared/assets/images/responsive-support/book-with-grad-cap.svg"
            alt="A book with a graduation cap"
          />
        }
      />
    </MiddleSchoolCurriculumLayout>
  );
}

export default MiddleSchoolCurriculumPage;
